import { OrderSource } from "../../../../../../../types";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model) => {
	const content = item.additionalFields?.initiator?.callSign ?? "";

	let backgroundColor: string | undefined;
	if (typeof item.source === "string") {
		const [colorOrange, colorGreen] = ["#ffa940", "#73d13d"];
		const colorMap = {
			[OrderSource.DISPATCHER]: colorGreen,
			[OrderSource.EXECUTOR]: colorOrange,
		} as Partial<Record<OrderSource, string>>;
		backgroundColor = colorMap[item.source] || undefined;
	}

	return { content, backgroundColor };
};

export default cellProcessing;
